import { fnv64 } from '@/utils/data/fieldHashing';
import type { ValidationFormData } from '@/types/validationFormTypes';

// Sort object keys so form data hashes identically whether it arrives via JSON.parse
// (C# property order) or RHF getValues() (insertion order). Arrays stay order-sensitive.
const sortKeysReplacer = (_key: string, value: unknown): unknown =>
  value && typeof value === 'object' && !Array.isArray(value)
    ? Object.fromEntries(
        Object.entries(value as Record<string, unknown>).sort(([a], [b]) =>
          a < b ? -1 : a > b ? 1 : 0
        )
      )
    : value;

/** Length of the 16-hex FNV-64 output — used to detect persisted legacy-format hashes. */
export const FORM_HASH_LENGTH = 16;

/**
 * Hash the entire form (all DG items) via key-sorted JSON. O(graph size) — use only for
 * explicit save/submit comparisons, not in middleware or hot paths.
 */
export function computeFormDataHash(formData: ValidationFormData): string {
  return fnv64(JSON.stringify(formData, sortKeysReplacer));
}

/** Imperative check — use in callbacks/effects, not in render. */
export function hasUnsavedChanges(
  formData: ValidationFormData,
  lastSavedFormHash: string
): boolean {
  return computeFormDataHash(formData) !== lastSavedFormHash;
}
